import { isFieldErrorResponse, useApiOrdersV1SalesOrdersUpdatePartialUpdate } from 'api';
import { useNotification } from 'features';
import { UseFormReturn } from 'form';

import { UploadDocumentProps } from '../../../document';
import {
  SalesOrderUpdateFormInputValues,
  SalesOrderUpdateFormValues,
} from '../../pages/SalesOrderUpdate/SalesOrderUpdate';
import { redirectToSalesOrderPage } from '../../utils/redirectToSalesOrderPage';
import { scrollToFirstError } from '../../utils/scrollToFirstError';
import { useUploadAndCreateSalesOrderDocument } from '..';

export const useUpdateSalesOrder = (
  form: UseFormReturn<SalesOrderUpdateFormInputValues, unknown, SalesOrderUpdateFormValues>
) => {
  const { setError, getValues } = form;
  const uploadAndCreateDocument = useUploadAndCreateSalesOrderDocument();
  const { open } = useNotification();

  return useApiOrdersV1SalesOrdersUpdatePartialUpdate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            setError(field as keyof SalesOrderUpdateFormValues, {
              message: error.response.data[field],
            });
          });

          requestAnimationFrame(() => {
            scrollToFirstError();
          });
        }

        if (error.status === 403) {
          open({ message: 'You do not have authorization to perform this action', type: 'error' });
        }
      },
      async onSuccess(data) {
        const documents = getValues().documents;
        if (documents) {
          await Promise.all(
            documents?.map((document: UploadDocumentProps) => uploadAndCreateDocument(document, { slug: data.slug }))
          );
        }

        redirectToSalesOrderPage(data.slug);
      },
    },
  });
};
